var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 564,
    viewBox: "0 0 1920 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.658203,
    y: 0.210938,
    width: 1920,
    height: 563.725,
    fill: "#5865F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.658203,
    y: 0.210938,
    width: 1920,
    height: 563.725,
    fill: "url(#pattern0)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0553767,
    height: 0.188608
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1301_396",
    transform: "scale(0.000576841 0.00196467)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1301_396",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDesign);
export default __webpack_public_path__ + "static/media/background_design.3aa9960d0597fb55ffdcdedde6cf65a6.svg";
export { ForwardRef as ReactComponent };